{
  "pending": "oczekujące"
}
